import React from 'react';
import { Container } from './PageNotFound.styles';

const PageNotFound = () => {
  return (
    <Container>
      <p>Page not found</p>
    </Container>
  );
};

export default PageNotFound;
